import React, {useContext, useEffect, useRef} from 'react';
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import {filterFormConfigByHiddenValue, formSubmitHandler} from "./functions";
import {FormContext} from "./FormContext";
import MagicFormInput from "./MagicFormInput";
import "./style.scss"

const RasaForm = () => {
  const helper = useContext(FormContext);
  const setMyData = helper.setMyData
  const myData = helper.myData


  const formRef = useRef()


  useEffect(() => {
    // خیلی قشنگ میشه اگه کاربر به محض باز کردن فرم روی اولین اینپوت یا سلکتا یل هر چی فوکس بشه

    const filteredFormConfig = filterFormConfigByHiddenValue({
      formArray: myData.formConfig, hidden: myData?.hidden,
    })
    setMyData({filteredFormConfig})
  }, [myData.formConfig]);


  return (<div>
    <h3 className="page-header">{myData.title}</h3>
    <div className="form-component0">
      {/*{modalIsOpen ? (<RLookUp*/}
      {/*  id={JSON.parse(sessionStorage.getItem("rlookup")).id}*/}
      {/*  variables={JSON.parse(sessionStorage.getItem("rlookup")).variables}*/}
      {/*  callBackDataHandler={lookupCallBackDataHandler}*/}
      {/*  modalHandler={[modalIsOpen, setModalIsOpen]}*/}
      {/*  fieldName={JSON.parse(sessionStorage.getItem("rlookup")).fieldName}*/}
      {/*/>) : null}*/}
      <form
        ref={formRef}
        className="rasaForm "
      >
        <MagicFormInput
          myData={myData}
          setMyData={setMyData}
        />
      </form>
      <div className={"w-100 text-center"}>
        <button
          className="btn btnCustom btnSubmit submit-button"
          disabled={myData.mode === 'sending'}
          onClick={() => {
            // formSubmitHandler(formRef, data.entity, setSubmitResponse, next);
            void formSubmitHandler({myData, setMyData, ref: formRef})
          }}
        >
          ثبت
        </button>
        {myData.mode === 'sending' && <div className={'position-absolute text-center w-100'}>
          <div className={'badge bg-info text-dark'}> در حال ارسال اطلاعات...</div>

        </div>}
      </div>
      {myData?.showBarcode && (<>
        <div className="barcodeLabelContainer">
          <div className="border-black" style={{}}>
            <div className="barcodeLabel">
              <div
                className={"border border-dark rounded-3"}
                style={{margin: " 0 auto", width: "max-content"}}
              >
                {/*<ComponentToPrintBarcodeInEditSection*/}
                {/*  submitResponse={submitResponse}*/}
                {/*  ref={refToPrintBarcode}*/}
                {/*/>*/}
              </div>
            </div>
          </div>
        </div>

        <br/>
        <div className={"text-center"}>
          {/* here is Section Code To Print */}
          {/* End ::: here is Section Code To Print */}
        </div>
      </>)}
    </div>

  </div>);
};

export default React.memo(RasaForm);
